// extracted by mini-css-extract-plugin
export default {"overflow":"Popup_overflow__CZ+tw","active":"Popup_active__dAhJa","popup":"Popup_popup__DDMD3","close":"Popup_close__eT9CH"};